export enum FormInviteType {
    RequiredInvitation = 1,
    ReminderInvitation = 2,
    ShareInvitation = 3,
}